<template>
    <div class="flickerManage">

        <div class="breadcrumb">闪屏管理
            <el-button class="right_f" type="primary" @click="newflicker">新增</el-button>
        </div>

        <div class="flicker">
            <el-select v-model="appSource" @change="getflickers">
                <el-option label="全部" value='0'></el-option>
                <el-option label="安卓" value='1'></el-option>
                <el-option label="IOS" value='2'></el-option>
            </el-select>
            <el-select v-model="flickerStatus" @change="getflickers">
                <el-option label="全部" value='0'></el-option>
                <el-option label="草稿" value='1'></el-option>
                <el-option label="待上线" value='2'></el-option>
                <el-option label="已上线" value='3'></el-option>
                <el-option label="过期" value='4'></el-option>
            </el-select>
        </div>

        <div class="com-list">
            <el-table :data="flickers" style="overflow-x: auto;">
                <el-table-column prop="index" label="序号" width="80">
                </el-table-column>
                <el-table-column prop="description" label="广告说明">
                </el-table-column>
                <el-table-column prop="appSource" label="终端" width="80">
                </el-table-column>
                <el-table-column prop="applicableCampus" label="适用学校" width="120">
                </el-table-column>
                <el-table-column prop="showtime" label="展示时间">
                </el-table-column>
                <el-table-column prop="state" label="状态" width="80">
                </el-table-column>
                <el-table-column prop="latestdo" label="最近操作记录" width="200">
                </el-table-column>
                <el-table-column inline-template label="操作">
                    <span>
                        <el-button class="option" type="text" @click="editNew(row.id)">编辑</el-button>
                        <el-button class="option" type="text" @click="deleteflicker(row)">删除</el-button>
                    </span>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination v-show="totalCount > 0" layout="prev, pager, next, jumper" :page-size="pageSize" :current-page="pageNum" :total="totalCount"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                appSource: '0',
                flickerStatus: '0',
                totalCount: 0,
                operatorId: "",
                pageNum: 1,
                pageSize: 10,
                flickers: [],
                operatorId: ''
            }
        },
        mounted() {
            this.operatorId = this.$store.state.user.userId;
            //请求获取flickers数据
            this.getflickers();
        },
        methods: {
            getflickers() {
                this.flickers = [];

                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/v1/ad/adFlash/list',
                    body: JSON.stringify({
                        appSource: this.appSource * 1,
                        pageNum: this.pageNum,
                        pageSize: this.pageSize,
                        state: this.flickerStatus * 1
                    })
                }).then((response) => {
                    if (response.data.error === 10000) {
                        let dataList = response.data.data.list;
                        this.totalCount = response.data.data.total;

                        if (dataList && dataList.length > 0) {
                            for (let i = 0; i < dataList.length; i++) {
                                let index = i + 1,
                                    description = dataList[i].description,
                                    appSource = dataList[i].appSource,
                                    applicableCampus = dataList[i].applicableCampus == 0 ? '全部' : '部分',
                                    startTime = new Date(dataList[i].startTime).format('yyyy/MM/dd'),
                                    endTime = new Date(dataList[i].endTime).format('yyyy/MM/dd'),
                                    lastOperateTime = new Date(dataList[i].lastOperateTime).format('yyyy/MM/dd'),
                                    lastOperator = dataList[i].lastOperator,
                                    id = dataList[i].id,
                                    state = dataList[i].state,
                                    operatorId = dataList[i].lastOperatorId;

                                switch (appSource) {
                                    case 0:
                                        appSource = '全部'
                                        break;
                                    case 1:
                                        appSource = '安卓'
                                        break;
                                    default:
                                        appSource = 'IOS'
                                        break;
                                }

                                switch (state) {
                                    case 1:
                                        state = '草稿'
                                        break;
                                    case 2:
                                        state = '待上线'
                                        break;
                                    case 3:
                                        state = '已上线'
                                        break;
                                    default:
                                        state = '过期'
                                        break;
                                }

                                this.flickers.push({
                                    index,
                                    description,
                                    appSource,
                                    applicableCampus,
                                    state,
                                    id,
                                    operatorId,
                                    showtime: startTime + ' - ' + endTime,
                                    latestdo: lastOperator + '  ' + lastOperateTime
                                })
                            }
                        }
                    }
                });
            },
            newflicker() {
                location.href = "#/yunying/flicker/newFlickerScreen";
            },
            editNew(id) {
                location.href = "#/yunying/flicker/newFlickerScreen?flickerId=" + id;
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.getflickers();
            },
            deleteflicker(row) {
                this.$confirm('你确定要删除此条广告吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        method: 'GET',
                        url: this.$util.domain + '/adminapi/v1/ad/adFlash/del/' + row.id,
                        params: {
                            id: row.id * 1,
                            operatorId: this.operatorId * 1
                        }
                    }).then(response => {
                        if (response.data.error === 10000) {
                            this.getflickers();
                        }
                    }).catch(response => {

                    })
                })
            }
        }
    }
</script>
<style>
    .flickerManage .el-select {
        display: inline-block;
    }

    .flickerManage img {
        display: block;
        width: 70%;
        height: 80%;
        margin: 10px;
    }

    .flickerManage span .el-button {
        width: 70px;
        padding: 5px;
        border: solid 1px #999;
    }

    .flickerManage .el-input {
        display: inline-block;
    }

    .flickerManage .el-button {
        display: inline-block;
    }

    .flickerManage .el-button+.el-button {
        margin-left: 0;
    }

    .flicker {
        margin-left: 30px;
        margin-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// flickerScreen.vue?26d47a4f